// @ts-nocheck
/* eslint-disable */
export const appChevronRight16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 14.25L10.75 8.25L5.25 2.25" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'chevron-right-16' as const
};